import React, { useEffect } from 'react'
import { Grid, Typography } from '@mui/material'
import { connect } from 'react-redux'
import { getBookedLessonsOfATeacher } from '../../../actions/learningScheduleForStudent'
import Spinner from '../../ui/Spinner'
import BookedLessonsTable from './BookedLessonsTable'

const BookedLessonsManager = ({
  learningScheduleForStudent: { bookedLessons, loading },
  auth: { user },
  getBookedLessonsOfATeacher,
}) => {
  useEffect(() => {
    getBookedLessonsOfATeacher(user._id)
  }, [getBookedLessonsOfATeacher, user._id])

  console.log('bookedLessons:', bookedLessons)
  return (
    <Grid
      container
      direction="column"
      alignItems="center"
      spacing={2}
      className="container"
    >
      <Grid item>
        <Typography
          variant="h4"
          style={{ textTransform: 'uppercase', fontWeight: '500' }}
        >
          Lesson management
        </Typography>
      </Grid>

      <Grid item>
        {loading ? (
          <Spinner />
        ) : bookedLessons.length === 0 ? (
          <Typography variant="body1">There are not any booked lessons.</Typography>
        ) : (
          <BookedLessonsTable bookedLessons={bookedLessons.sort(function (a, b) {
            return new Date(b.bookedTime[0].start) - new Date(a.bookedTime[0].start)
          })} />
        )}
      </Grid>
    </Grid>
  )
}

const mapStateToProps = (state) => ({
  learningScheduleForStudent: state.learningScheduleForStudent,
  auth: state.auth,
})

export default connect(mapStateToProps, { getBookedLessonsOfATeacher })(
  BookedLessonsManager
)
